import React, { useEffect } from "react";
import css from "./Advertising.module.scss";
import SecOne from "./SecOne/SecOne";
import SecTwo from "./SecTwo/SecTwo";
import SecThree from "./SecThree/SecThree";
import { constants } from "assets/constants";
import { Helmet } from "react-helmet";

const Advertising = () => {
    return (
        <div className={css.advertising}>
            <Helmet>
                <title>{constants.titles.services_advertising}</title>
                <meta name="description" content={constants.descriptions.services_advertising} />
            </Helmet>
            <SecOne />
            <SecTwo />
            <SecThree />
        </div>
    );
};

export default Advertising;
